import {
  Box,
  Grid,
  GridColumn,
  Typography,
} from "@kohler-dsm-library/kohler-core"
import React from "react"
import styles from "@/components/Remedy/components/ErgonomicsSection/ErgonomicsSection.module.scss"
import { BentoBox } from "@/components/Remedy/components/ErgonomicsSection/BentoBox"

export const ErgonomicsSection = () => {
  return (
    <Box
      component="section"
      mod="charcoal"
      className={styles["ergonomics-section"]}
    >
      <Grid>
        <GridColumn span={12} spanSmall={6} textAlign="center">
          <Typography className={styles["__title"]} size="h3" component="span">
            The details make the difference
          </Typography>
        </GridColumn>
        <GridColumn span={12} spanSmall={6}>
          <div className={styles["__bento-container"]}>
            <BentoBox
              type="video"
              title="Ergonomic seating"
              description="The angled backrest and upright seating position add comfort and aid in breath regulation for a more enjoyable experience."
              videoUrlLarge={`https://kohler.scene7.com/is/content/${
                process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes(
                  "www.kohler.com"
                )
                  ? "kohlergbhprod"
                  : "kohlergbhqa"
              }/PXP/bento/TL_10mbps.mp4`}
              videoUrlSmall={`https://kohler.scene7.com/is/content/${
                process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes(
                  "www.kohler.com"
                )
                  ? "kohlergbhprod"
                  : "kohlergbhqa"
              }/PXP/bento/TL_5mbps_small.mp4`}
              videoId="ergonomic_seating_video"
            />
            <BentoBox
              type="video"
              title="Accommodating design"
              description="The spacious interior provides an ideal experience for a range of body types."
              videoUrlLarge={`https://kohler.scene7.com/is/content/${
                process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes(
                  "www.kohler.com"
                )
                  ? "kohlergbhprod"
                  : "kohlergbhqa"
              }/PXP/bento/TR_10mbps.mp4`}
              videoUrlSmall={`https://kohler.scene7.com/is/content/${
                process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes(
                  "www.kohler.com"
                )
                  ? "kohlergbhprod"
                  : "kohlergbhqa"
              }/PXP/bento/TR_5mbps_small.mp4`}
              videoId="accomodating_design_video"
            />
            <BentoBox
              size="full"
              type="video"
              title="Thoughtfully positioned & adjustable water outlets"
              description="Two adjustable water outlets provide optimal flow of water circulation for filtration and cleaning needs."
              videoUrlLarge={`https://kohler.scene7.com/is/content/${
                process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes(
                  "www.kohler.com"
                )
                  ? "kohlergbhprod"
                  : "kohlergbhqa"
              }/PXP/bento/MC_10mbps.mp4`}
              videoUrlSmall={`https://kohler.scene7.com/is/content/${
                process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes(
                  "www.kohler.com"
                )
                  ? "kohlergbhprod"
                  : "kohlergbhqa"
              }/PXP/bento/MC_5mbps_small.mp4`}
              videoLoop={true}
              videoId="adjustable_jet_video"
            />
            <BentoBox
              type="image"
              title="Slanted rim and headrest"
              description="A chamfered edge and cushioned headrest offer comfortable support for the neck and arms."
              imageUrlLarge="/content/dam/remedy-assets/bento/BL.png"
              imageUrlSmall="/content/dam/remedy-assets/bento/BL_small.png"
            />
            <BentoBox
              type="image"
              title="Integrated guide rail"
              description="Built-in finger grooves along the exterior of the bath assist with entering and exiting the Ice Bath."
              imageUrlLarge="/content/dam/remedy-assets/bento/BR.png"
              imageUrlSmall="/content/dam/remedy-assets/bento/BR_small.png"
            />
          </div>
        </GridColumn>
      </Grid>
    </Box>
  )
}
